import { render, staticRenderFns } from "./previewBasic.vue?vue&type=template&id=368acd19&scoped=true&lang=html&"
import script from "./previewBasic.vue?vue&type=script&lang=js&"
export * from "./previewBasic.vue?vue&type=script&lang=js&"
import style0 from "./previewBasic.vue?vue&type=style&index=0&id=368acd19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368acd19",
  null
  
)

export default component.exports